import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { TextField, Container, Typography } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import NcsBanner from './NcsBanner';
import { useDispatch } from 'react-redux';
import { emailSignIn } from 'actions/authAction';
import { ncsSignIn } from 'api';

const styles = {
  container: {
    backgroundColor: 'white',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    padding: 40,
    marginTop: 0
  },
  button: {
    backgroundColor: '#ffc220',
    fontSize: 16,
    marginTop: 20,
    textTransform: 'none',
    fontWeight: 'bold'
  },
  declarationText: {
    paddingTop: 16,
    marginBottom: 16,
    fontSize: '15px',
    lineHeight: 1.5
  },
  fieldLabel: {
    fontSize: '16px',
    fontWeight: 400,
    marginBottom: 8,
    marginTop: 8
  },
};

const useStyles = makeStyles({
  disabled: {
    backgroundColor: '#e5e5e5 !important'
  }
});


const MaterialStyles = theme => ({
  formWrapper: {
    padding: '0 15px',
    width: '40%',
    [theme.breakpoints.down('md')]: {
      padding: '0 10px',
    }
  }
});


const NcsLogin = ({ classes }) => {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const mui = useStyles();
  const [password, setPassword] = useState('');
  const [formData, setFormData] = useState({
    email: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    // no data while redirection, move to regular sign in
    if (!location.state?.email) {
      history.push("/signin");
    }

    setFormData(prev => ({
      ...prev,
      email: location.state?.email || '',
    }));
  }, [location.state]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    setError('');
    try {
      // if ncsSignIn returns a bad response, it will set error as login failed in the catch block
      await ncsSignIn({ email: formData.email, password });

      dispatch(emailSignIn(formData.email, password));
    } catch (err) {
      setError('Login failed. Please check your credentials and try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={{ backgroundColor: '#E5E5E5', minHeight: '100vh', paddingTop: 100, paddingBottom: 20 }}>
      <Container maxWidth={"lg"}>
        <NcsBanner />
        <form onSubmit={handleSubmit}>
          <div container spacing={0} style={styles.container}>
            <div item xs={12} md={4} className={classes.formWrapper}>
              <div>
                <Typography style={styles.fieldLabel}>{t('emailLabelNCS')}<span style={{ color: '#f44336' }}>*</span></Typography>
                <TextField
                  fullWidth
                  name="email"
                  type="email"
                  value={formData.email}
                  disabled
                  inputProps={{ className: mui.disabled }}
                  variant="outlined"
                  size="small"
                />
              </div>
              <div>
                <Typography style={styles.fieldLabel}>NCS Portal Password <span style={{ color: '#f44336' }}>*</span></Typography>
                <TextField
                  fullWidth
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  variant="outlined"
                  size="small"
                  disabled={isSubmitting}
                />
              </div>
              {error && (
                <Typography style={{ color: '#d32f2f', marginTop: 8 }}>
                  {error}
                </Typography>
              )}
              <Typography style={styles.declarationText}>
                By logging into the Mentor To Go platform and you agree to the
                {' '}
                <a href="/termsofservice" target="_blank">
                  Terms of Service
                </a>{' '}
                &{' '}
                <a href="/privacypolicy" target="_blank">
                  Privacy Policy
                </a>{' '}
                of the Mentor To Go platform
              </Typography>
              <Button
                type="submit"
                variant="contained"
                fullWidth
                style={styles.button}
                disabled={isSubmitting || !password}
              >
                {isSubmitting ? 'Logging in…' : 'Login to Mentor To Go'}
              </Button>
            </div>
          </div>
        </form>
      </Container>
    </div>
  );
};

export default withStyles(MaterialStyles)(NcsLogin);
